import * as Types from 'src/actions/investment/update/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import Investment from 'src/entities/Investment';
import ValidatorService from 'src/services/validation/Validation.service';

export interface UpdateInvestmentAttempt extends Action {
  type: Types.UPDATE_INVESTMENT_ATTEMPT;
}

export interface UpdateInvestmentSuccess extends Action {
  type: Types.UPDATE_INVESTMENT_SUCCESS;
}

export interface UpdateInvestmentFailure extends Action {
  type: Types.UPDATE_INVESTMENT_FAILURE;
  payload: {};
}

export type UpdateInvestmentAction = UpdateInvestmentAttempt |
  UpdateInvestmentSuccess |
  UpdateInvestmentFailure;

export interface UpdateInvestmentThunk extends
  ThunkAction<Promise<UpdateInvestmentAction>, RootState, null> {
}

export const updateInvestmentAttempt: ActionCreator<UpdateInvestmentAttempt> = () => (
  {
    type: Types.UPDATE_INVESTMENT_ATTEMPT,
  }
);

export const updateInvestmentSuccess: ActionCreator<UpdateInvestmentSuccess> = () => (
  {
    type: Types.UPDATE_INVESTMENT_SUCCESS,
  }
);

export const updateInvestmentFailure: ActionCreator<UpdateInvestmentFailure> = (error: {}) => (
  {
    type: Types.UPDATE_INVESTMENT_FAILURE,
    payload: error,
  }
);

export const updateInvestment: ActionCreator<UpdateInvestmentThunk> = (
  investment: Investment
): UpdateInvestmentThunk => {

  return (dispatch: Dispatch<RootState>): Promise<UpdateInvestmentAction> => {
    dispatch(updateInvestmentAttempt());

    return ApiClient.investment.update(investment.id!, investment)
      .then((): UpdateInvestmentSuccess => {
        return dispatch(updateInvestmentSuccess());
      }).catch((e: { response: { data: { error: {} } } }): UpdateInvestmentFailure => {
        const errorMessages = ValidatorService
        .translateValidations(e && e.response && e.response.data && e.response.data.error);
        return dispatch(updateInvestmentFailure(errorMessages));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/investment/update/UpdateInvestment.actions.tsx